import { EstadoVacio } from '../components/ui/Estados';

/**
 * Marcador de una pantalla todavía no migrada.
 * Se retira a medida que avanzan las fases del plan de migración.
 */
export function EnConstruccion({ titulo }: { titulo: string }) {
  return (
    <EstadoVacio
      icono="temporizador"
      titulo={`${titulo} · en preparación`}
      descripcion="Esta sección se está construyendo en la nueva consola. Mientras tanto sigue disponible en la versión anterior."
    />
  );
}
